export default theme => ({
  root: {
    width: '100%',
    height: '100%',
    cursor: 'default',
    '& .ag-header': {
      zIndex: 0
    },
    '& .ag-header-cell, & .ag-cell': {
      paddingLeft: '10px !important',
      paddingRight: '10px !important'
    }
  }
});